import produce from 'immer';
import * as actions from './actions';

export const initialState = {
  adminRelationships: { data: { org: null, me: null, subscribedFeatures: null }, loading: false, error: null },
  adminApplication: { data: null, loading: false, error: null },
  myAdminApplications: { data: null, loading: false, error: null },
  schoolAdminRelationships: { data: null, loading: false, error: null },
  adminDeleted: { data: null, loading: false, error: null },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.FETCH_ADMIN_RELATIONSHIPS_REQUEST:
      draft.adminRelationships.loading = true;
      break;
    case actions.FETCH_ADMIN_RELATIONSHIPS_SUCCESS:
      draft.adminRelationships.data = action.payload.adminRelationships;
      draft.adminRelationships.loading = false;
      break;
    case actions.FETCH_SCHOOL_ADMIN_RELATIONSHIPS_REQUEST:
      draft.schoolAdminRelationships.loading = true;
      draft.schoolAdminRelationships.data = null;
      break;
    case actions.FETCH_SCHOOL_ADMIN_RELATIONSHIPS_SUCCESS:
      draft.schoolAdminRelationships.data = action.payload.schoolAdminRelationships;
      draft.schoolAdminRelationships.loading = false;
      break;
    case actions.FETCH_SCHOOL_ADMIN_RELATIONSHIPS_FAILURE:
      draft.schoolAdminRelationships.loading = false;
      draft.schoolAdminRelationships.error = action.payload.error;
      break;
    case actions.FETCH_MY_ADMIN_APPLICATIONS_REQUEST:
      draft.myAdminApplications.loading = true;
      break;
    case actions.FETCH_MY_ADMIN_APPLICATIONS_SUCCESS:
      draft.myAdminApplications.data = action.payload.myAdminApplications;
      draft.myAdminApplications.loading = false;
      break;
    case actions.FETCH_MY_ADMIN_APPLICATIONS_FAILURE:
      draft.myAdminApplications.loading = false;
      draft.myAdminApplications.error = action.payload.error;
      break;
    case actions.CREATE_ADMIN_APPLICATION_REQUEST:
      draft.adminApplication.loading = true;
      break;
    case actions.CREATE_ADMIN_APPLICATION_SUCCESS:
      draft.adminApplication.data = action.payload.adminApplication;
      draft.adminApplication.loading = false;
      break;
    case actions.CREATE_ADMIN_APPLICATION_FAILURE:
      draft.adminApplication.loading = false;
      draft.adminApplication.error = action.payload.error;
      break;
    case actions.DELETE_ADMIN_RELATIONSHIP_REQUEST:
      draft.adminDeleted.loading = true;
      draft.adminDeleted.data = null;
      break;
    case actions.DELETE_ADMIN_RELATIONSHIP_SUCCESS:
      draft.adminDeleted.data = action.payload.adminDeleted;
      draft.adminDeleted.loading = false;

      if (action.payload.schoolAdminRelationships) {
        draft.schoolAdminRelationships.data = action.payload.schoolAdminRelationships;
      }
      break;
    case actions.DELETE_ADMIN_RELATIONSHIP_FAILURE:
      draft.adminDeleted.loading = false;
      draft.adminDeleted.error = action.payload.error;
      break;
    case actions.INIT_ADMIN_APPLICATION:
      draft.adminApplication = { data: null, loading: false, error: null };
      break;
    case actions.CLEAR_ADMIN_APPLICATION_ERROR:
      draft.adminApplication.error = null;
      break;
    case actions.CLEAR_ADMIN_DELETED:
      draft.adminDeleted = { data: null, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
